<template>
  <base-button
    :class="{
      'ps--ml-px': !isFirst,
      'ps-rounded-l-md ': isFirst,
      'ps-rounded-r-md ': isLast,
      'ps-bg-gray-300': isActive,
      'ps-bg-white': !isActive
    }"
    @button-click="$emit('button-click', $event)"
    @button-mouseenter="$emit('button-mouseenter')"
    @button-mouseleave="$emit('button-mouseleave')"
    class="ps-relative ps-inline-flex ps-items-center ps-px-2 ps-py-2 ps-border ps-border-solid ps-border-gray-300 ps-text-xs ps-leading-5 ps-font-medium ps-text-gray-700 hover:ps-text-gray-500 focus:ps-z-10 focus:ps-outline-none focus:ps-border-blue-300 focus:ps-shadow-outline-blue active:ps-bg-gray-100 active:ps-text-gray-700 ps-transition ps-ease-in-out ps-duration-150"
  >
    <slot />
  </base-button>
</template>

<script>
import BaseButton from '@/components/buttons/BaseButton'

export default {
  name: 'ButtonGrouped',
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseButton
  }
}
</script>
